import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import Panel from '@/components/Panel'
import DokumentPZ from '@/components/DokumentPZ'
import WydanieZMagazynu from '@/components/WydanieZMagazynu'
import OdpadyOpakowanie from '@/components/OdpadyOpakowanie'
import NosnikOpakowanie from '@/components/NosnikOpakowanie'
import Odpady from '@/components/Odpady'
import Opakowanie from '@/components/Opakowanie'
import Waga from '@/components/Waga'
import ArtykulWaga from '@/components/ArtykulWaga'
import Artykul from '@/components/Artykul'
import DokumentPW from '@/components/DokumentPW'
import EtykietaDrukuj from '@/components/EtykietaDrukuj'
import EtykietaDrukujPW from '@/components/EtykietaDrukujPW'
import PanelAdmin from '@/components/PanelAdmin'
import ZleceniaWydanie from '@/components/ZleceniaWydanie'
import ZleceniaOdpady from '@/components/ZleceniaOdpady'
import ZleceniaArtykul from '@/components/ZleceniaArtykul'
import DokumentPZWydanie from '@/components/DokumentPZWydanie'
import DokumentPZOdpady from '@/components/DokumentPZOdpady'
import DokumentPZPrzyjecie from '@/components/DokumentPZPrzyjecie'
import PanelKonfiguracyjny from '@/components/PanelAdministracyjny/PanelKonfiguracyjny'
import Uzytkownicy from '@/components/PanelAdministracyjny/Uzytkownicy'
import PotwierdzenieOK from '@/components/PotwierdzenieOK'
import PotwierdzenieERROR from '@/components/PotwierdzenieERROR'
import DokumentPWPrzyjecie from '@/components/DokumentPWPrzyjecie'
import EtykietaDrukujPWE from '@/components/EtykietaDrukujPWE'

Vue.use(Router)


export default new Router({
  mode: "history",
  routes: [
    {
      path: '/hello',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/main',
      name: 'Panel',
      component: Panel
    },
    {
      path: '/dokumentypz',
      name: 'Dokumenty PZ',
      component: DokumentPZ 
    },
    {
      path: '/wydaniezmag',
      name: 'Wydanie z Magazynu',
      component: WydanieZMagazynu 
    },
    {
      path: '/nosnikopakowanie',
      name: 'Nośnik Opakowanie',
      component: NosnikOpakowanie
    },
    {
      path: '/odpadyopakowanie',
      name: 'Odpady Opakowanie',
      component: OdpadyOpakowanie
    },
    {
      path: '/odpadypz',
      name: 'OdpadyPZ',
      component: DokumentPZOdpady 
    },
    {
      path: '/odpady',
      name: 'Odpady',
      component: Odpady 
    },
    {
      path: '/opakowanie',
      name: 'Opakowanie',
      component: Opakowanie
    },
    {
      path: '/waga',
      name: 'Waga',
      component: Waga
    },
    {
      path: '/artykulwaga',
      name: 'ArtykulWaga',
      component: ArtykulWaga
    },
    {
      path: '/artykul',
      name: 'Artykul',
      component: Artykul
    },
    {
      path: '/dokumentypw',
      name: 'Dokumenty PW',
      component: DokumentPW 
    },
    {
      path: '/etykieta',
      name: 'Drukuj Etykietę',
      component: EtykietaDrukuj
    },
    {
      path: '/etykietapw',
      name: 'Drukuj Etykietę',
      component: EtykietaDrukujPW
    },
    {
      path: '/paneladmin',
      name: 'Panel Administracyjny',
      component: PanelAdmin
    },
    {
      path: '/zleceniawydanie',
      name: 'Zlecenia',
      component: ZleceniaWydanie
    },
    {
      path: '/zleceniaodpady',
      name: 'Zlecenia',
      component: ZleceniaOdpady
    },
    {
      path: '/zleceniaartykul',
      name: 'Zlecenia',
      component: ZleceniaArtykul
    },
    {
      path: '/dokumentpzwydanie',
      name: 'Wydanie z Magazynu',
      component: DokumentPZWydanie 
    },
    {
      path: '/dokumentpzprzyjecie',
      name: 'Przyjęcie na Magazyn',
      component: DokumentPZPrzyjecie 
    },
    {
      path: '/paneladmin/panelkonfiguracyjny',
      name: 'Panel konfiguracyjny',
      component: PanelKonfiguracyjny
    },
    {
      path: '/paneladmin/uzytkownicy',
      name: 'Użytkownicy',
      component: Uzytkownicy
    },
    {
      path: '/potwierdzenieok',
      name: 'Potwierdzenie zapisu do bazy',
      component: PotwierdzenieOK
    },
    {
      path: '/potwierdzenieerror',
      name: 'Potwierdzenie zapisu do bazy',
      component: PotwierdzenieERROR
    },
    {
      path: '/dokumentpwprzyjecie',
      name: 'Dokument PW',
      component: DokumentPWPrzyjecie
    },
    {
      path: '/pweetykieta',
      name: 'Drukuj Etykietę',
      component: EtykietaDrukujPWE
    },
  ]
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  });
}



// WEBPACK FOOTER //
// ./src/router/index.js